import { LandingFooter } from '@/components/layout/LandingFooter';
import { LandingNavbar } from '@/components/layout/LandingNavbar';
import { AboutSection, AppPromoSection, CoreValuesSection } from './sections/AboutSection';
import { ContactSection, CtaSection } from './sections/ContactSection';
import { HeroSection } from './sections/HeroSection';
import { PromoSection } from './sections/PromoSection';
import { NetworksSection, ServicesSection } from './sections/ServicesSection';

export function LandingPage() {
  return (
    <div className="min-h-screen">
      <LandingNavbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <NetworksSection />
        <PromoSection />
        <AboutSection />
        <CoreValuesSection />
        <AppPromoSection />
        <ContactSection />
        <CtaSection />
      </main>
      <LandingFooter />
    </div>
  );
}
